export default "__VITE_ASSET__2683548f__"